import { render, staticRenderFns } from "./VacancyProject.vue?vue&type=template&id=0ba6052f"
import script from "./VacancyProject.vue?vue&type=script&lang=js"
export * from "./VacancyProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports